import CustomCard from "components/Atoms/CustomCard"
import React from "react"
import DcRequestsList from "./table/DcRequestsList"

const DcRequestsTable = () => {
  return (
    <div className="p-3">
      <CustomCard className="vt-dispatch-table-view p-0">
        <DcRequestsList />
      </CustomCard>
    </div>
  )
}

export default DcRequestsTable
